module.exports = __webpack_public_path__ + "static/img/process.0bf676d6.png";